import { _ as _objectSpread2, a as _toConsumableArray } from './_rollupPluginBabelHelpers-fb970440.js';
import React from 'react';
import { useQuery } from '@apollo/client';
import 'react-helmet';
import 'react-router-dom';
import { useResponsiveParams, Text, MixedGridGroup } from 'quanta-ui';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './queries-3df8abcc.js';
import { E as Error } from './error-ee5266a9.js';
import { L as Loading } from './loading-c16d3bd3.js';
import './queries-a3e6305b.js';
import { G as GET_CUSTOMER_TYPE_DOMAIN, C as CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, a as CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL } from './queries-5e809970.js';

function ProposerCustomerReadOnly(_ref) {
  var _reactiveVarData$prop, _reactiveVarData$prop2, _reactiveVarData$prop3, _reactiveVarData$prop4, _reactiveVarData$prop5, _reactiveVarData$prop6, _reactiveVarData$prop7, _reactiveVarData$prop8, _reactiveVarData$prop9, _reactiveVarData$prop10, _reactiveVarData$prop11, _reactiveVarData$prop12, _reactiveVarData$prop13, _reactiveVarData$prop14, _reactiveVarData$prop15, _reactiveVarData$prop16, _reactiveVarData$prop17, _reactiveVarData$prop18, _reactiveVarData$prop19, _reactiveVarData$prop20, _reactiveVarData$prop21, _reactiveVarData$prop22, _reactiveVarData$prop23, _reactiveVarData$prop24, _reactiveVarData$prop25, _reactiveVarData$prop26, _reactiveVarData$prop27, _reactiveVarData$prop28, _reactiveVarData$prop29, _reactiveVarData$prop30, _reactiveVarData$prop31, _reactiveVarData$prop32, _reactiveVarData$prop33, _reactiveVarData$prop34, _reactiveVarData$prop35, _reactiveVarData$prop36, _reactiveVarData$prop37, _reactiveVarData$prop38, _reactiveVarData$prop39, _reactiveVarData$prop40, _reactiveVarData$prop41, _reactiveVarData$prop42, _reactiveVarData$prop43, _reactiveVarData$prop44, _reactiveVarData$prop45, _reactiveVarData$prop46, _reactiveVarData$prop47, _reactiveVarData$prop48, _reactiveVarData$prop49, _reactiveVarData$prop50, _reactiveVarData$prop51, _reactiveVarData$prop52, _reactiveVarData$prop53, _reactiveVarData$prop54, _reactiveVarData$prop55, _reactiveVarData$prop56, _reactiveVarData$prop57, _reactiveVarData$prop58, _reactiveVarData$prop59, _reactiveVarData$prop60, _reactiveVarData$prop61, _reactiveVarData$prop62, _reactiveVarData$prop63, _reactiveVarData$prop64, _reactiveVarData$prop65, _reactiveVarData$prop66, _reactiveVarData$prop67, _reactiveVarData$prop68, _reactiveVarData$prop69, _reactiveVarData$prop70, _reactiveVarData$prop71, _reactiveVarData$prop72, _reactiveVarData$prop73, _reactiveVarData$prop74, _reactiveVarData$prop75, _reactiveVarData$prop76, _reactiveVarData$prop77, _reactiveVarData$prop78, _reactiveVarData$prop79, _reactiveVarData$prop80, _reactiveVarData$prop81, _reactiveVarData$prop82, _reactiveVarData$prop83, _reactiveVarData$prop84, _reactiveVarData$prop85, _renderExpandedCards$, _renderExpandedCards$2;

  var reactiveVarData = _ref.reactiveVarData,
      goToStep = _ref.goToStep,
      renderExpandedCards = _ref.renderExpandedCards;

  var getDomainData = function getDomainData(domainArr, searchText, searchType, returnType) {
    return domainArr.find(function (d) {
      var _d$;

      return ((_d$ = d["".concat(searchType)]) === null || _d$ === void 0 ? void 0 : _d$.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase());
    }) ? domainArr.find(function (d) {
      var _d$2;

      return ((_d$2 = d["".concat(searchType)]) === null || _d$2 === void 0 ? void 0 : _d$2.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase());
    })["".concat(returnType)] : '';
  };

  var repeatForDesktop = 3,
      repeatForMobile = 2;
  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop
  });

  var _useQuery = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first'
  }),
      loadingCustomerType = _useQuery.loading,
      errorCustomerType = _useQuery.error,
      dataCustomerType = _useQuery.data;

  var _useQuery2 = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first'
  }),
      loadingIndividualDropDownDetails = _useQuery2.loading,
      errorIndividualDropDownDetails = _useQuery2.error,
      dataIndividualDropDownDetails = _useQuery2.data;

  var _useQuery3 = useQuery(CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first'
  }),
      loadingOrganisationDropDownDetails = _useQuery3.loading,
      errorOrganisationDropDownDetails = _useQuery3.error,
      dataOrganisationDropDownDetails = _useQuery3.data;

  if (loadingCustomerType || loadingIndividualDropDownDetails || loadingOrganisationDropDownDetails) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  if (errorCustomerType || errorIndividualDropDownDetails || errorOrganisationDropDownDetails) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Error, {
      error: errorCustomerType || errorIndividualDropDownDetails || errorOrganisationDropDownDetails
    }));
  }

  var customerTypeList = dataCustomerType.customerTypeList;
  dataIndividualDropDownDetails.idProofTypeList;
      var maritalStatusList = dataIndividualDropDownDetails.maritalStatusList,
      nationalityList = dataIndividualDropDownDetails.nationalityList,
      genderList = dataIndividualDropDownDetails.genderList,
      salutationList = dataIndividualDropDownDetails.salutationList;
  var organisationList = dataOrganisationDropDownDetails.organisationList;
  var proposerDetailsData = [(reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop = reactiveVarData.proposerDetailsMeta) === null || _reactiveVarData$prop === void 0 ? void 0 : _reactiveVarData$prop.isNewCustomer) === false ? {
    grid_type: 'data',
    grid_data: [{
      label: 'Customer Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop2 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop2 === void 0 ? void 0 : _reactiveVarData$prop2.id
    }, {
      label: 'CRN',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop3 = reactiveVarData.proposerDetailsMeta) === null || _reactiveVarData$prop3 === void 0 ? void 0 : _reactiveVarData$prop3.crn
    }]
  } : {
    grid_type: 'data',
    grid_data: [{
      label: 'CRN',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop4 = reactiveVarData.proposerDetailsMeta) === null || _reactiveVarData$prop4 === void 0 ? void 0 : _reactiveVarData$prop4.crn
    }]
  }, (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop5 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop5 === void 0 ? void 0 : _reactiveVarData$prop5.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal"
    }, "Personal Details"),
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'Title',
      text: /*#__PURE__*/React.createElement("span", null, (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop6 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop6 === void 0 ? void 0 : _reactiveVarData$prop6.title) !== '' ? getDomainData(salutationList, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop7 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop7 === void 0 ? void 0 : _reactiveVarData$prop7.title, 'code', 'value') : '')
    }, {
      label: 'Gender',
      text: /*#__PURE__*/React.createElement("span", null, (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop8 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop8 === void 0 ? void 0 : _reactiveVarData$prop8.gender) !== '' ? getDomainData(genderList, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop9 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop9 === void 0 ? void 0 : _reactiveVarData$prop9.gender, 'code', 'value') : '')
    }, {
      label: 'Date of Birth',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop10 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop10 === void 0 ? void 0 : _reactiveVarData$prop10.proposerDOB
    }, {
      label: 'First Name',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop11 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop11 === void 0 ? void 0 : _reactiveVarData$prop11.firstName
    }, {
      label: 'Middle Name',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop12 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop12 === void 0 ? void 0 : _reactiveVarData$prop12.middleName
    }, {
      label: 'Last Name',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop13 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop13 === void 0 ? void 0 : _reactiveVarData$prop13.lastName
    }, {
      label: 'Marital Status',
      text: /*#__PURE__*/React.createElement("span", null, (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop14 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop14 === void 0 ? void 0 : _reactiveVarData$prop14.maritalStatus) !== '' ? getDomainData(maritalStatusList, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop15 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop15 === void 0 ? void 0 : _reactiveVarData$prop15.maritalStatus, 'code', 'value') : '')
    }, {
      label: 'Nationality',
      text: /*#__PURE__*/React.createElement("span", null, (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop16 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop16 === void 0 ? void 0 : _reactiveVarData$prop16.nationality) !== '' ? getDomainData(nationalityList, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop17 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop17 === void 0 ? void 0 : _reactiveVarData$prop17.nationality, 'code', 'value') : '')
    },
    /*SADivya -CR P2_233 : KYC*/
    {
      label: "Mother's Maiden Name",
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop18 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop18 === void 0 ? void 0 : _reactiveVarData$prop18.motherMaidenName
    }, {
      label: 'CKYC ID Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop19 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop19 === void 0 ? void 0 : _reactiveVarData$prop19.ckycIdNumber
    }, {
      label: 'EIA Required',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop20 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop20 === void 0 ? void 0 : _reactiveVarData$prop20.eiaRequired
    }, {
      label: 'EIA Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop21 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop21 === void 0 ? void 0 : _reactiveVarData$prop21.eiaNumber
    }
    /*SADivya -CR P2_233 : KYC*/
    ]
  } : {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal"
    }, "Organisation Details"),
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'Organisation Name',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop22 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop22 === void 0 ? void 0 : _reactiveVarData$prop22.orgName
    }, {
      label: 'Organisation Type ',
      text: getDomainData(organisationList, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop23 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop23 === void 0 ? void 0 : _reactiveVarData$prop23.orgType, 'code', 'value')
    }, {
      label: 'Contact Person Name',
      maxLength: 40,
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop24 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop24 === void 0 ? void 0 : _reactiveVarData$prop24.contactName
    }]
  }, (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop25 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop25 === void 0 ? void 0 : _reactiveVarData$prop25.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ?
  /*SUDivya - CR P2_233 :KYC : Hide Identification Details */
  //  {
  //   title: <Text type="normal">Identification Details</Text>,
  //   grid_type: 'data',
  //   isBorderRequired: true,
  //   borderClassName: 'border-t-2 border-neutral pt-4',
  //   grid_data: [
  //     {
  //       label: 'ID Proof Type',
  //       text: (
  //         <span>
  //           {reactiveVarData?.proposerDetails?.idProofType !==
  //           ''
  //             ? getDomainData(
  //                 idProofTypeList,
  //                 reactiveVarData?.proposerDetails?.idProofType,
  //                 'code',
  //                 'value',
  //               )
  //             : ''}
  //         </span>
  //       ),
  //     },
  //     {
  //       label: 'ID Proof Number',
  //       text: reactiveVarData?.proposerDetails?.idProofNumber
  //         ?.toString()
  //         ?.toUpperCase(),
  //     },
  //   ],
  // }

  /*EUDivya - CR P2_233 :KYC : Hide Identification Details */
  null : {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal"
    }, "Tax Identification Details"),
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'Registration Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop26 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop26 === void 0 ? void 0 : _reactiveVarData$prop26.regNumber
    }, {
      label: 'TAN Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop27 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop27 === void 0 ? void 0 : (_reactiveVarData$prop28 = _reactiveVarData$prop27.tanNumber) === null || _reactiveVarData$prop28 === void 0 ? void 0 : _reactiveVarData$prop28.toUpperCase()
    }, {
      label: 'GST Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop29 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop29 === void 0 ? void 0 : (_reactiveVarData$prop30 = _reactiveVarData$prop29.gstNumber) === null || _reactiveVarData$prop30 === void 0 ? void 0 : _reactiveVarData$prop30.toUpperCase()
    },
    /*SADivya : CR P2_498 */
    {
      label: 'PAN Card Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop31 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop31 === void 0 ? void 0 : (_reactiveVarData$prop32 = _reactiveVarData$prop31.panNumber) === null || _reactiveVarData$prop32 === void 0 ? void 0 : (_reactiveVarData$prop33 = _reactiveVarData$prop32.toString()) === null || _reactiveVarData$prop33 === void 0 ? void 0 : _reactiveVarData$prop33.toUpperCase()
    },
    /*SADivya : CR P2_498 */

    /*SADivya -CR P2_233 : KYC*/
    {
      label: 'Certificate of Incorporation',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop34 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop34 === void 0 ? void 0 : _reactiveVarData$prop34.certificateOfInCorporation
    }, {
      label: 'udyog Aadhaar number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop35 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop35 === void 0 ? void 0 : _reactiveVarData$prop35.udyogAadhaarNumber
    }, {
      label: 'CKYC ID Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop36 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop36 === void 0 ? void 0 : _reactiveVarData$prop36.ckycIdNumber
    }
    /*EADivya -CR P2_233 : KYC*/
    ]
  }, (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop37 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop37 === void 0 ? void 0 : _reactiveVarData$prop37.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal"
    }, "Internal Employee"),
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'Employee Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop38 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop38 === void 0 ? void 0 : (_reactiveVarData$prop39 = _reactiveVarData$prop38.employeeNumber) === null || _reactiveVarData$prop39 === void 0 ? void 0 : (_reactiveVarData$prop40 = _reactiveVarData$prop39.toString()) === null || _reactiveVarData$prop40 === void 0 ? void 0 : _reactiveVarData$prop40.toUpperCase()
    }]
  } : null, (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop41 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop41 === void 0 ? void 0 : _reactiveVarData$prop41.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal"
    }, "Tax Identification Details"),
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'PAN Card Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop42 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop42 === void 0 ? void 0 : (_reactiveVarData$prop43 = _reactiveVarData$prop42.panNumber) === null || _reactiveVarData$prop43 === void 0 ? void 0 : (_reactiveVarData$prop44 = _reactiveVarData$prop43.toString()) === null || _reactiveVarData$prop44 === void 0 ? void 0 : _reactiveVarData$prop44.toUpperCase()
    }, {
      label: 'GST Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop45 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop45 === void 0 ? void 0 : (_reactiveVarData$prop46 = _reactiveVarData$prop45.gstNumber) === null || _reactiveVarData$prop46 === void 0 ? void 0 : _reactiveVarData$prop46.toUpperCase()
    }]
  } : null, {
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'Permanent Address',
      colSpan: repeat,
      text: [reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop47 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop47 === void 0 ? void 0 : (_reactiveVarData$prop48 = _reactiveVarData$prop47.permAddressLine1) === null || _reactiveVarData$prop48 === void 0 ? void 0 : _reactiveVarData$prop48.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop49 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop49 === void 0 ? void 0 : (_reactiveVarData$prop50 = _reactiveVarData$prop49.permAddressLine2) === null || _reactiveVarData$prop50 === void 0 ? void 0 : _reactiveVarData$prop50.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop51 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop51 === void 0 ? void 0 : (_reactiveVarData$prop52 = _reactiveVarData$prop51.permAddressLine3) === null || _reactiveVarData$prop52 === void 0 ? void 0 : _reactiveVarData$prop52.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop53 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop53 === void 0 ? void 0 : (_reactiveVarData$prop54 = _reactiveVarData$prop53.permLandmark) === null || _reactiveVarData$prop54 === void 0 ? void 0 : _reactiveVarData$prop54.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop55 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop55 === void 0 ? void 0 : (_reactiveVarData$prop56 = _reactiveVarData$prop55.permCityTownVillage) === null || _reactiveVarData$prop56 === void 0 ? void 0 : _reactiveVarData$prop56.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop57 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop57 === void 0 ? void 0 : (_reactiveVarData$prop58 = _reactiveVarData$prop57.permDistrict) === null || _reactiveVarData$prop58 === void 0 ? void 0 : _reactiveVarData$prop58.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop59 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop59 === void 0 ? void 0 : (_reactiveVarData$prop60 = _reactiveVarData$prop59.permState) === null || _reactiveVarData$prop60 === void 0 ? void 0 : _reactiveVarData$prop60.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop61 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop61 === void 0 ? void 0 : _reactiveVarData$prop61.permPincode].filter(function (a) {
        return a;
      }).join(',')
    }, {
      label: 'Communication Address',
      colSpan: repeat,
      text: [reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop62 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop62 === void 0 ? void 0 : (_reactiveVarData$prop63 = _reactiveVarData$prop62.commAddressLine1) === null || _reactiveVarData$prop63 === void 0 ? void 0 : _reactiveVarData$prop63.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop64 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop64 === void 0 ? void 0 : (_reactiveVarData$prop65 = _reactiveVarData$prop64.commAddressLine2) === null || _reactiveVarData$prop65 === void 0 ? void 0 : _reactiveVarData$prop65.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop66 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop66 === void 0 ? void 0 : (_reactiveVarData$prop67 = _reactiveVarData$prop66.commAddressLine3) === null || _reactiveVarData$prop67 === void 0 ? void 0 : _reactiveVarData$prop67.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop68 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop68 === void 0 ? void 0 : (_reactiveVarData$prop69 = _reactiveVarData$prop68.commLandmark) === null || _reactiveVarData$prop69 === void 0 ? void 0 : _reactiveVarData$prop69.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop70 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop70 === void 0 ? void 0 : (_reactiveVarData$prop71 = _reactiveVarData$prop70.commCityTownVillage) === null || _reactiveVarData$prop71 === void 0 ? void 0 : _reactiveVarData$prop71.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop72 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop72 === void 0 ? void 0 : (_reactiveVarData$prop73 = _reactiveVarData$prop72.commDistrict) === null || _reactiveVarData$prop73 === void 0 ? void 0 : _reactiveVarData$prop73.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop74 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop74 === void 0 ? void 0 : (_reactiveVarData$prop75 = _reactiveVarData$prop74.commState) === null || _reactiveVarData$prop75 === void 0 ? void 0 : _reactiveVarData$prop75.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop76 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop76 === void 0 ? void 0 : _reactiveVarData$prop76.commPincode].filter(function (a) {
        return a;
      }).join(',')
    }].filter(function (d) {
      return d;
    })
  }, (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop77 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop77 === void 0 ? void 0 : _reactiveVarData$prop77.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal"
    }, "Contact Details"),
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'Mobile Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop78 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop78 === void 0 ? void 0 : _reactiveVarData$prop78.mobileNo
    }, {
      label: 'Email Id',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop79 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop79 === void 0 ? void 0 : _reactiveVarData$prop79.emailID
    }, !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.proposalNumber) ? {
      colSpan: repeat,
      label: /*#__PURE__*/React.createElement("div", {
        className: "mt-4"
      }),
      text: /*#__PURE__*/React.createElement(Text, {
        severity: "action",
        className: "hover:underline cursor-pointer",
        onClick: function onClick(_) {
          goToStep(0);
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faEdit,
        className: "mr-1"
      }), /*#__PURE__*/React.createElement("span", {
        className: "font-bold"
      }, "Edit Details"))
    } : null].filter(function (d) {
      return d;
    })
  } : {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal"
    }, "Contact Details"),
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'Telephone Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop80 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop80 === void 0 ? void 0 : _reactiveVarData$prop80.phoneNo
    }, {
      label: 'Organisation Mobile Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop81 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop81 === void 0 ? void 0 : _reactiveVarData$prop81.mobileNo
    }, {
      label: 'FAX Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop82 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop82 === void 0 ? void 0 : _reactiveVarData$prop82.faxNo
    }, {
      label: 'Alternative Telephone Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop83 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop83 === void 0 ? void 0 : _reactiveVarData$prop83.altPhoneNo
    }, {
      label: 'Alternative Mobile Number',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop84 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop84 === void 0 ? void 0 : _reactiveVarData$prop84.altMobileNo
    }, {
      label: 'Organisation Email Id',
      text: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop85 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop85 === void 0 ? void 0 : _reactiveVarData$prop85.emailID
    }, !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.proposalNumber) ? {
      colSpan: repeat,
      label: /*#__PURE__*/React.createElement("div", {
        className: "mt-4"
      }),
      text: /*#__PURE__*/React.createElement(Text, {
        severity: "action",
        className: "hover:underline cursor-pointer",
        onClick: function onClick(_) {
          goToStep(0);
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faEdit,
        className: "mr-1"
      }), /*#__PURE__*/React.createElement("span", {
        className: "font-bold"
      }, "Edit Details"))
    } : null].filter(function (d) {
      return d;
    })
  }].filter(function (d) {
    return d;
  });
  var otherPropsForCards = {
    flow: 'cols',
    textType: 'normal',
    repeat: repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
    titleType: 'normal',
    useExpandablePaper: false,
    useGlobalExpandablePaper: true,
    globalTitleSeverity: 'info',
    globalTitleType: 'large',
    nullData: function nullData() {
      return /*#__PURE__*/React.createElement(Text, {
        severity: "neutral"
      }, "Not Captured");
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MixedGridGroup, _objectSpread2(_objectSpread2({
    data: proposerDetailsData
  }, otherPropsForCards), {}, {
    globalTitle: 'Proposer Details',
    expanded: renderExpandedCards && renderExpandedCards !== null && renderExpandedCards !== void 0 && renderExpandedCards.current ? renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$ = renderExpandedCards.current) === null || _renderExpandedCards$ === void 0 ? void 0 : (_renderExpandedCards$2 = _renderExpandedCards$.find(function (card) {
      var _card$cardName, _card$cardName$toStri;

      return (card === null || card === void 0 ? void 0 : (_card$cardName = card.cardName) === null || _card$cardName === void 0 ? void 0 : (_card$cardName$toStri = _card$cardName.toString()) === null || _card$cardName$toStri === void 0 ? void 0 : _card$cardName$toStri.toLowerCase()) === 'proposer customer';
    })) === null || _renderExpandedCards$2 === void 0 ? void 0 : _renderExpandedCards$2.flag : undefined,
    isToggleEnabled: true,
    setExpandedCards: function setExpandedCards(expanded) {
      if (renderExpandedCards && renderExpandedCards !== null && renderExpandedCards !== void 0 && renderExpandedCards.current) {
        var _renderExpandedCards$3, _renderExpandedCards$4;

        renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$3 = renderExpandedCards.current) === null || _renderExpandedCards$3 === void 0 ? void 0 : _renderExpandedCards$3.filter(function (card) {
          var _card$cardName2, _card$cardName2$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName2 = card.cardName) === null || _card$cardName2 === void 0 ? void 0 : (_card$cardName2$toStr = _card$cardName2.toString()) === null || _card$cardName2$toStr === void 0 ? void 0 : _card$cardName2$toStr.toLowerCase()) !== 'proposer customer';
        })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$4 = renderExpandedCards.current) === null || _renderExpandedCards$4 === void 0 ? void 0 : _renderExpandedCards$4.find(function (card) {
          var _card$cardName3, _card$cardName3$toStr;

          return (card === null || card === void 0 ? void 0 : (_card$cardName3 = card.cardName) === null || _card$cardName3 === void 0 ? void 0 : (_card$cardName3$toStr = _card$cardName3.toString()) === null || _card$cardName3$toStr === void 0 ? void 0 : _card$cardName3$toStr.toLowerCase()) === 'proposer customer';
        })), {}, {
          flag: expanded
        })]);
      }
    }
  })));
}

export { ProposerCustomerReadOnly as P };
